import { gql } from "@apollo/client";

export const UPDATE_TEMPLATE_ROW_EXTRACTION = gql`
  mutation updateTemplateRowExtraction(
    $templateId: String
    $clientIdentifier: String
    $input: TemplateRowExtractionInput!
  ) {
    invoiceInterpretation {
      updateTemplateRowExtraction(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
        input: $input
      ) {
        success
      }
    }
  }
`;
